module.exports = __webpack_public_path__ + "static/media/lib5.8bc8b216.jpg";